module.exports = __webpack_public_path__ + "static/card-blog3-47bb87fb754b37775a7af3dffd10c490.jpg";